import {Representative} from 'modules/blocks'
export const RepresentativePage = ()=> {
    return (
        <Representative />
    )
}
